<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">日售票走势</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="日期">
            <el-date-picker
              v-model="chooseDate"
              type="date"
              style="width: 60rem"
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="echart">
          <div>
            日售票总金额
            <PieEchartTicket :chartData="dayTicketTotal"></PieEchartTicket>
          </div>
          <div>
            日售票统计同比
            <LineEchart2Ticket
              :legendData="legendData"
              :chartData="dayTicketCompare"
            ></LineEchart2Ticket>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
import { getTypeDataByTimes, getYOYTrendByTimes } from "@/api/src/bigData";
import moment from "moment";
export default {
  name: "TicketDayTrend",
  controller: "UI",
  action: "TicketDayTrend",
  data() {
    return {
      chooseDate: new Date(),
      dayTicketTotal: {},
      dayTicketCompare: {},
      legendData: [new Date().getFullYear(), new Date().getFullYear() - 1],
    };
  },
  mounted: function () {
    this.onSearch();
  },
  methods: {
    getCharts() {
      this.legendData = [
        this.chooseDate.getFullYear(),
        this.chooseDate.getFullYear() - 1,
      ];
      let params = {
        district: this.CNF("app.districtCode"),
        districtCode: this.CNF("app.districtCode"),
        polityType: 3,
        startTime: this.formatterDate(this.chooseDate),
        endTime: this.formatterDate(this.chooseDate),
      };
      //日售票总金额
      getTypeDataByTimes({ ...params, timeType: "hour", timeValue: 24 }).then(
        (res) => {
          if (res.data) {
            this.dayTicketTotal = {
              value: res.data.totalCost,
              maxValue: 1000000,
            };
          }
        }
      );
      //日售票统计同比
      getYOYTrendByTimes({ ...params, timeType: "hour", timeValue: 24 }).then(
        (res) => {
          if (res.data) {
            let dataList = res.data.dataList || {};
            let Now = dataList[this.legendData[0]];
            let Last = dataList[this.legendData[1]];
            this.dayTicketCompare = {
              days: Now.map((item) => {
                return moment(item.dataTime).format("HH时");
              }),
              data: Now.map((item) => {
                return item.count;
              }),
              dataLast: Last.map((item) => {
                return item.count;
              }),
            };
          }
        }
      );
    },
    formatterDate(val) {
      let year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      return year + "-" + month + "-" + day;
    },
    onSearch() {
      this.getCharts();
    },
    onCancel() {
      this.chooseDate = new Date();
      this.getCharts();
    },
  },
};
</script>

<style scoped lang="scss">
.echart {
  position: relative;
  width: 100%;
  height: 100%;
}
.echart > div {
  width: 60%;
  height: 48%;
  margin: 0 auto 15px;
  color: #2bc5ff;
  font-weight: bold;
  text-align: center;
}
::v-deep .el-input__inner {
  width: 322px;
}
</style>